var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"message-detail-item-wrapper",attrs:{"id":"MessageDetailItemWrapper"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"contents"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }